import React from 'react'
import PropTypes from 'prop-types'
import { CategoryMenuItems } from './CategoryMenuItems'
import CategoryMenuType from './CategoryMenuType'
import { connect } from 'react-redux'
import slugify from 'react-slugify'
import MediaQuery from 'react-responsive'

const checkMenuContext = (onlyCash, context = []) => {
  const currentContext = onlyCash ? 'cash' : 'points'
  return context.indexOf(currentContext) > -1
}

const CategoryMenuWrapper = ({ onlyCash, context, children }) => {
  return checkMenuContext(onlyCash, context) ? children : null
}

const formatSubItems = (dynamicAction, productCategories, stores, items) => {
  const itemsMenu = []

  if (dynamicAction === 'loadCategories') {
    productCategories.items.slice(0, 10).map(st => (itemsMenu.push({
      label: st.name,
      className: '',
      path: `/search?category=${st.id}`
    })))

    itemsMenu.length >= 10 && itemsMenu.push({
      label: 'Ver todos',
      parentClassName: 'hover-ver-todos py-1 border-top border-color-ui-3',
      className: 'ver-todos txt-font-body-bold color-brand-1',
      path: `/categories`
    })
  }

  if (dynamicAction === 'loadEcommerceStores') {
    stores.ecommerce.slice(0, 10).map(st => (itemsMenu.push({
      label: st.name,
      className: '',
      path: `/vendor?vendor=${st.supplierId}`
    })))
    itemsMenu.length >= 10 && itemsMenu.push({
      label: 'Ver todos',
      parentClassName: 'hover-ver-todos py-1 border-top border-color-ui-3',
      className: 'ver-todos txt-font-body-bold color-brand-1',
      path: `/stores`
    })
  }

  if (dynamicAction === 'loadVouchersStores') {
    stores.vouchers.slice(0, 10)
      .map(st => (
        itemsMenu.push({
          label: st.name,
          className: '',
          path: `/vendor?vendor=${st.supplierId}`
        })
      ))
    itemsMenu.length >= 10 && itemsMenu.push({
      label: 'Ver todos',
      parentClassName: 'hover-ver-todos py-1 border-top border-color-ui-3',
      className: 'txt-font-body-bold',
      path: `/stores/vouchers`
    })
  }
  if (dynamicAction === null) {
    const labelSeeAll = ['Ver todos', 'Ver todas as categorias', 'Ver todos os itens']
    items.length > 0 && items
      .map(st => {
        return labelSeeAll.indexOf(st.label) === -1
          ? (
            itemsMenu.push({ ...st })
          ) : itemsMenu.push({ ...st,
            parentClassName: 'hover-ver-todos py-1 border-top border-color-ui-3',
            className: 'txt-font-body-bold py-1' })
      })
  }
  return itemsMenu
}
const CategoryMenu = ({ menus, onlyCash, productCategories, stores, openTabletMenu }) => {
  return (
    <div className='col px-0'>
      <MediaQuery minWidth={600} maxWidth={1024}>
        <ul className='primary-menu mx-0'>
          <li className='close-hamburger-menu bg-brand-4 color-ui-white px-2 mb-1'>
            <a
              onClick={openTabletMenu}
              className={`mn-item color-ui-white fechar-menu d-flex align-items-center`}
              tabIndex={0}
            >
              <i className='icon icon_left_app color-ui-white mr-1' aria-hidden='true' />
              Fechar menu
            </a>
          </li>
          {menus && menus.map(
            ({ label, enabled, type, path, sku, items, context, dynamicAction }, index) => {
              return (
                <CategoryMenuWrapper onlyCash={onlyCash} context={context}>
                  <li className={`px-1 cat-${slugify(label, { delimiter: '-' })}`} key={index}>
                    <CategoryMenuType
                      type={type}
                      sku={sku}
                      path={path}
                      label={label}
                      enabled={enabled}
                      className={`txt-uppercase txt-font-body ${type}`}
                    />
                    {
                      typeof dynamicAction !== 'undefined' ? (
                        <CategoryMenuItems
                          type={type}
                          items={formatSubItems(dynamicAction, productCategories, stores, items)}
                          dynamicAction={dynamicAction}
                          indexParent={index}
                        />
                      ) : <CategoryMenuItems
                        type={type}
                        items={formatSubItems(null, productCategories, stores, items)}
                        dynamicAction={dynamicAction}
                        indexParent={index}
                      />
                    }

                  </li>
                </CategoryMenuWrapper>
              )
            }
          )}
        </ul>
      </MediaQuery>
      <MediaQuery minWidth={1025}>
        <ul className='primary-menu row mx-0'>
          {menus && menus.map(
            ({ label, enabled, type, path, sku, items, context, dynamicAction }, index) => {
              return (
                <CategoryMenuWrapper onlyCash={onlyCash} context={context}>
                  <li className={`col-auto px-1 cat-${slugify(label, { delimiter: '-' })}`} key={index}>
                    <CategoryMenuType
                      type={type}
                      sku={sku}
                      path={path}
                      label={label}
                      enabled={enabled}
                      className={`txt-uppercase txt-font-body ${type}`}
                    />
                    {
                      typeof dynamicAction !== 'undefined' ? (
                        <CategoryMenuItems
                          type={type}
                          items={formatSubItems(dynamicAction, productCategories, stores, items)}
                          dynamicAction={dynamicAction}
                          indexParent={index}
                        />
                      ) : <CategoryMenuItems
                        type={type}
                        items={formatSubItems(null, productCategories, stores, items)}
                        dynamicAction={dynamicAction}
                        indexParent={index}
                      />
                    }

                  </li>
                </CategoryMenuWrapper>
              )
            }
          )}
        </ul>
      </MediaQuery>
    </div>

  )
}

CategoryMenu.propTypes = {
  menus: PropTypes.arrayOf(PropTypes.shape(CategoryMenuItems.propTypes))
    .isRequired,
  onlyCash: PropTypes.bool,
  productCategories: PropTypes.object,
  stores: PropTypes.object,
  openTabletMenu: PropTypes.func
}

const mapStateToProps = ({
  productCategories,
  stores
}) => ({
  productCategories,
  stores
})

export default connect(
  mapStateToProps,
  null
)(CategoryMenu)



// WEBPACK FOOTER //
// ./src/App/MainMenu/CategoryMenu/CategoryMenu.js